<template>
  <div
    :id="id"
    :style="{ width: '95%', height: '100%', margin: '0 auto' }"
  ></div>
</template>

<script>
export default {
  props: ["id", "chartsData"],
  data() {
    return {};
  },
  watch: {
    chartsData: {
      handler(newvalue, oldvalue) {
        this.drawLine();
      },
      deep: true,
    },
  },

  methods: {
    drawLine() {
      let _this = this;
      if (document.getElementById(this.id) == null) {
        return;
      }
      this.$echarts.dispose(document.getElementById(this.id));
      let myChart = this.$echarts.init(document.getElementById(this.id));
      myChart.setOption({}, true);
      let option = {
        grid: {
          top: "60px",
          left: "80px",
          right: "15px",
          bottom: "60px",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            let result = params[0].name + "<br>";
            params.forEach(function (item) {
              result +=
                item.marker +
                " " +
                item.seriesName +
                " : " +
                item.value +
                _this.chartsData.unit +
                "</br>";
            });
            return result;
          },
        },
        legend: {
          type: "scroll",
          top: "1%",
          right: "2%",
          textStyle: {
            color: "#333",
            fontSize: 12,
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            rotate: 20,
            color: "#CBCBCB",
            fontSize: 12,
            margin: 15,
          },
          data: this.chartsData.xData,
        },
        yAxis: {
          type: "value",
          name: `单位(${this.chartsData.unit})`,
          nameTextStyle: {
            color: "#666",
            fontSize: 12,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },

          axisLabel: {
            color: "#999",
            fontSize: 12,
          },
          splitLine: {
            lineStyle: {
              type: "solid",
              color: "#EBEBEB",
            },
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: this.chartsData.xData.length >= 15 ? true : false,
            startValue: 0, //数据窗口范围的起始数值
            endValue: 14,
            xAxisIndex: [0],
            handleSize: 30,
            height: 10, //组件高度
            bottom: 5, //右边的距离
          },
        ],
        series: [
          {
            name: this.chartsData.title,
            data: this.chartsData.dataArr,
            type: "bar",
            symbolSize: 8,
            itemStyle: {
              color: "#28CCCB",
            },
            animation: true,
            barWidth:15
          },
        ],
      };

      myChart.setOption(option, true);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 20);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
</style>
